import { handleResponse, handleError } from "./apiUtils";
//const baseUrl = process.env.REACT_APP_API_URL + "/api/users/";
const baseUrl = "/api/users";

export function getAllUsers() {
  return fetch(baseUrl, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getUser(userName) {
  return fetch(baseUrl + "?userName=" + userName, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function updateUserAdimn(profile) {
  return fetch(baseUrl + "/Admin", {
    method: "PUT", // POST for create, PUT to update when id already exists.
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(profile),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else if (response.status === 400) {
        const status = await response.json();
        if (status.hasOwnProperty("errors")) {
          const errors = status.errors;
          if (
            errors.apiResponseMessage &&
            errors.apiResponseMessage.length > 0
          ) {
            return errors.apiResponseMessage[0];
          }
          // if (errors.NewPassword && errors.NewPassword.length > 0) {
          //   return errors.NewPassword[0];
          // }
        }
        return false;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      return error;
    });
}

export function updateUser(profile) {
  return fetch(baseUrl, {
    method: "PUT",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(profile),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else if (response.status === 400) {
        const status = await response.json();
        if (status.hasOwnProperty("errors")) {
          const errors = status.errors;
          if (
            errors.apiResponseMessage &&
            errors.apiResponseMessage.length > 0
          ) {
            return errors.apiResponseMessage[0];
          }
        }
        return false;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      return error;
    });
}

export function createNewUser(newuser) {
  return fetch(baseUrl + "/Admin", {
    method: "POST",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(newuser),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else if (response.status === 400) {
        const status = await response.json();
        if (status.hasOwnProperty("errors")) {
          const errors = status.errors;
          if (
            errors.apiResponseMessage &&
            errors.apiResponseMessage.length > 0
          ) {
            return errors.apiResponseMessage[0];
          }
          if (errors.NewPassword && errors.NewPassword.length > 0) {
            return errors.NewPassword[0];
          }
        }
        return false;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      return error;
    });
}

export function deleteUser(userId) {
  return fetch(baseUrl + "/Admin/" + userId, {
    method: "DELETE",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response;
      }
      // if (response.status === 400) {
      //   // So, a server-side validation error occurred.
      //   // Server side validation returns a string error message, so parse as text instead of json.
      //   const error = await response.text();
      //   throw new Error(error);
      // }
      // throw new Error("Network response was not ok.");
      else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      throw error;
    });
}

export function invertStatus(userName) {
  return fetch(baseUrl + "Admin/InvertStatus/" + userName, {
    method: "PUT", // POST for create, PUT to update when id already exists.
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function setUpMfa() {
  return fetch(baseUrl + "/SetUpMfa", {
    method: "POST",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function remove2FA(userId) {
  return fetch(baseUrl + "/Admin/Remove2FA", {
    method: "DELETE",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(userId),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return true;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      throw error;
    });
}

export function pwdReset() {
  return fetch(baseUrl + "/Admin/PwdReset", {
    method: "POST",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return true;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      return error;
    });
}
